import { render, staticRenderFns } from "./size-editor.vue?vue&type=template&id=08040a34&scoped=true&"
import script from "./size-editor.vue?vue&type=script&lang=js&"
export * from "./size-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08040a34",
  null
  
)

export default component.exports